import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>The code you entered is for a pediatric formula and the member is 21 years of age or older.  </p>

				<div className="button" onClick={() => this.props.navigate('D18A')}>Continue</div>
			</div>
		);
	}
}